var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, observable, computed } from "mobx";
import { createTransformer } from "mobx-utils";
import { PulseBetMarketAdditionalData, ProgressStatus, WinningDataInner, Parser, PulseBetProgressData, PulseBetProgressPeriodData, CalculatedPeriodHelper } from "../../../data";
import { PlayByPlayIncidentTypes, GameStatuses } from "./enums";
import { MasterEventModel } from "./MasterEventModel";
import { PulseBetsTypes } from "../../../data/enums";
import { statusModifier } from "../helpers";
import { OpenPulseBetViewModel } from "./models";
import { EventsManager } from "sb-js-extends";
export class MyPulseBetsData {
    constructor(provider, oddsUtil, dict, cmsConfig) {
        /*istanbul ignore next */
        this.hasAnyOpenPulseBets = createTransformer((eventTypeId) => {
            return this.openViewModels.some(openBet => openBet.pulseBetMetadata.typeId === eventTypeId);
        });
        /*istanbul ignore next */
        this.getOpenPulseBets = createTransformer((eventTypeId) => {
            return this.openViewModels.filter(openBet => openBet.pulseBetMetadata.typeId === eventTypeId);
        });
        this.name = "MyPulseBetsData";
        this.provider = provider;
        this.userInfo = provider.userInfo;
        this.eventsManager = new EventsManager();
        this.oddsUtil = oddsUtil;
        this.dict = dict;
        this.calculatedPeriodHelperDependency = CalculatedPeriodHelper.getInstance();
        this.userInfo.onLogin[this.name] = this.onLogin;
        this.userInfo.onLogout[this.name] = this.onLogout;
        this.userInfo.current ? this.onLogin() : this.onLogout();
        this.openViewModels = [];
        this.pulseBetTypes = this.getPulseBetTypes();
        this.durationInMili = cmsConfig.durationInMili;
        this.updateOpenBetsInterval = cmsConfig.updateOpenBetsInterval;
        this.trackColor = cmsConfig.trackColor;
        this.openMyPulseBetsDelay = cmsConfig.openMyPulseBetsDelay;
        this.removePulseInterval = cmsConfig.removeBetIntervalInMilli;
        this.isAnyBetsAfterSettlement = true;
        this.redirectToDefaultGroupDelay = cmsConfig.redirectToDefaultGroupDelay;
    }
    //Todo: write tests!!
    /**
     * @function  onLogin  executed on Login of customer
     */
    onLogin() {
        if (this.userInfo.current) {
            this.isUserLogged = true;
            this.currencySign = this.userInfo.current.currencyCode;
            this.calculatedPeriodHelperDependency.setCurrentUserInfo(this.userInfo.current);
            this.initMyPulseBetData();
        }
    }
    /**
     * @function  onLogout execute on Logout of customer
     */
    onLogout() {
        this.isUserLogged = false;
        this.currencySign = "";
        this.calculatedPeriodHelperDependency.setCurrentUserInfo(undefined);
        this.clearMyPulseBetData();
    }
    /**
     * @function setParams sets parameters to the store, subscribe to 'onPlayByPlayUpdate' event and starts BasePlayByPlay timer
     *
     * @param masterEventId the id of the master(main) event
     * @param branchID id of event's branch
     */
    /*istanbul ignore next */
    setParams(masterEventId, masterEventBranchId, masterEventGameTime, gameStatus, isActive) {
        if (!this.userInfo.current) {
            return;
        }
        if (!this.masterEvent || this.masterEvent.id !== masterEventId) {
            this.masterEvent = new MasterEventModel({
                id: masterEventId,
                branchId: masterEventBranchId,
                gameTime: masterEventGameTime,
                gameStatus
            });
            this.initMyPulseBetData();
        }
        else {
            this.masterEvent.gameTime = masterEventGameTime;
            if (this.masterEvent.gameStatus !== gameStatus) {
                this.masterEvent.gameStatus = gameStatus;
            }
            for (let openBet of this.openViewModels) {
                openBet.pulseBetProgressData.expiredBetProgressInMilliseconds = (this.masterEvent.gameTime - openBet.startTimeOfBet) * 1000;
            }
        }
        this.isMyPulseBetActive = isActive;
    }
    gameTime(gameTimeInSeconds) {
        this.masterEvent.gameTime = gameTimeInSeconds;
        for (let openBet of this.openViewModels) {
            openBet.pulseBetProgressData.expiredBetProgressInMilliseconds = (this.masterEvent.gameTime - openBet.startTimeOfBet) * 1000;
        }
    }
    initMyPulseBetData() {
        if (this.masterEvent) {
            this.eventsManager.addEventListener("onPlayByPlayUpdate", this, this.onPlayByPlayUpdate.bind(this), true);
            this.eventsManager.addEventListener("onSuccessfullyPlacedBet", this, this.successfullyPlacedBetUpdate.bind(this), true);
            this.eventsManager.addEventListener("CurrentEventTime", this, this.gameTime.bind(this), true);
            this.provider.basePlayByPlay.startMonitor(this.masterEvent.id, this.masterEvent.branchId, this.name);
            // NOTE:
            // We convert `this.masterEvent.id` to number to match the
            // definition in legacy:
            // public static async Task<JSONValue> getOpenPulseBets(int masterEventId)
            this.provider.bettingHistoryPageMethods.getOpenPulseBets(parseInt(this.masterEvent.id, 10), this.successfulOpenPulseBetsCallback, this.errorOpenPulseBetsCallback);
            this.setUpdateOpenPulseBetsData();
        }
    }
    setUpdateOpenPulseBetsData() {
        this.updateOpenBetsTimeout = setTimeout(() => {
            // NOTE:
            // We convert `this.masterEvent.id` to number to match the
            // definition in legacy:
            // public static async Task<JSONValue> getOpenPulseBets(int masterEventId)
            this.provider.bettingHistoryPageMethods.getOpenPulseBets(parseInt(this.masterEvent.id, 10), this.successfulOpenPulseBetsCallback, this.errorOpenPulseBetsCallback);
            this.setUpdateOpenPulseBetsData();
        }, this.updateOpenBetsInterval);
    }
    clearMyPulseBetData() {
        if (this.masterEvent) {
            this.provider.basePlayByPlay.stopMonitor(this.masterEvent.id, this.name);
            this.eventsManager.removeEventListener("onPlayByPlayUpdate", this, true);
            this.eventsManager.removeEventListener("CurrentEventTime", this, true);
            this.eventsManager.removeEventListener("onSuccessfullyPlacedBet", this, true);
        }
        clearTimeout(this.updateOpenBetsTimeout);
    }
    successfullyPlacedBetUpdate() {
        this.setDelayedOpenPulseBetsCallOnNotification();
    }
    setDelayedOpenPulseBetsCallOnNotification() {
        setTimeout(() => {
            // NOTE:
            // We convert `this.masterEvent.id` to number to match the
            // definition in legacy:
            // public static async Task<JSONValue> getOpenPulseBets(int masterEventId)
            this.provider.bettingHistoryPageMethods.getOpenPulseBets(parseInt(this.masterEvent.id, 10), this.successfulOpenPulseBetsCallback, this.errorOpenPulseBetsCallback);
        }, this.openMyPulseBetsDelay);
    }
    /*istanbul ignore next */
    successfulOpenPulseBetsCallback(response) {
        let jsonData = eval(response);
        if (jsonData) {
            for (let key in jsonData) {
                if (jsonData[key]) {
                    let openPulseBet = jsonData[key];
                    if (openPulseBet && key === "New") {
                        this.isAnyBetsAfterSettlement = true;
                        this.openViewModels = this.getPurchases(openPulseBet);
                    }
                }
            }
        }
        this.eventsManager.dispatchEvent("onUpdateMyPulseBet", this.openViewModels.length, true);
    }
    getWiningValueFormatted(viewModel, index) {
        let odds = viewModel.pulseBetMetadata.periods[index].europeanOdds;
        let stake = viewModel.stake;
        let calculatedWin = Math.floor(+(stake * odds * 100).toPrecision(12)) / 100;
        calculatedWin = viewModel.bonusInfo.isFreeBet && !viewModel.bonusInfo.isRiskFreeBet ? calculatedWin - stake : calculatedWin;
        return this.calculatedPeriodHelperDependency.formatWinnings(calculatedWin);
    }
    getPeriodStatus(qPar1, qPar2) {
        if (qPar1 < this.masterEvent.gameTime && qPar2 + qPar1 > this.masterEvent.gameTime) {
            return ProgressStatus.Current;
        }
        else if (qPar1 > this.masterEvent.gameTime) {
            return ProgressStatus.PreRun;
        }
        else if (qPar1 + qPar2 < this.masterEvent.gameTime) {
            return ProgressStatus.PostRun;
        }
        return ProgressStatus.Current;
    }
    getStatusClass(status) {
        return statusModifier[status] || "";
    }
    /*istanbul ignore next */
    getPurchases(purchases) {
        let parsedResponse = [];
        for (let jsonData of purchases) {
            let purchase = Parser.SPPurchaseParser(jsonData);
            let additionalData = new PulseBetMarketAdditionalData({
                name: purchase.selections[0].eventTypeName,
                branchID: "1",
                currencySign: purchase.currencyCode,
                durationInMilli: this.durationInMili,
                typeId: purchase.selections[0].eventTypeId,
                marketId: purchase.selections[0].eventId,
                periods: this.getPeriods(purchase.selections),
                isDanger: false
            });
            let openView = new OpenPulseBetViewModel(purchase.bets[0].deposit, purchase.bets[0].gain, additionalData, purchase.selections[0].qPar1, this.masterEvent.gameTime * 1000, purchase.purchaseId, (inProgressData) => false, (inProgressData) => { }, (inProgressData) => { }, Object.assign({}, this.trackColor), {
                isFreeBet: purchase.bets[0].isFreeBet,
                isRiskFreeBet: purchase.bets[0].isRiskFreeBet
            });
            /*istanbul ignore next */
            this.reCalculateState("", openView);
            openView.isFinished = openView.winningsData.winnings[2].winningStatus === ProgressStatus.PostRun;
            let wonSelection = purchase.selections.find(sel => sel.statusId === 2);
            if (wonSelection) {
                // NOTE:
                // We convert string arguments to number to match the definition in legacy
                openView.gain = +Math.floor(+this.oddsUtil.convertFormat(+wonSelection.odds, parseInt(wonSelection.eventTypeId, 10), 13, undefined, 1, undefined, parseInt(wonSelection.branchId, 10), undefined, undefined) * openView.stake * 100).toPrecision(12) / 100;
                openView.finishedState = {
                    status: {
                        won: { amount: this.calculatedPeriodHelperDependency.formatWinnings(openView.gain) },
                        actions: { text: this.dict.RepeatBet, handler: () => { } }
                    }
                };
                openView.isFinished = true;
                setTimeout(this.removeExpiredBet.bind(this, openView.purchaseId), this.removePulseInterval);
            }
            /*istanbul ignore next */
            openView.pulseBetProgressData = new PulseBetProgressData({
                startTime: openView.periodFrames[0].start,
                endTime: openView.periodFrames[2].end,
                expiredBetProgressInMilliseconds: (this.masterEvent.gameTime - purchase.selections[0].qPar1) * 1000,
                periods: [{
                        startTime: openView.periodFrames[0].start,
                        duration: purchase.selections[0].qPar2 + 1,
                        id: purchase.purchaseId,
                        periodNumber: 1
                    },
                    {
                        startTime: openView.periodFrames[1].start,
                        duration: purchase.selections[1].qPar2 + 1,
                        id: purchase.purchaseId,
                        periodNumber: 2
                    },
                    {
                        startTime: openView.periodFrames[2].start,
                        duration: purchase.selections[2].qPar2 + 1,
                        id: purchase.purchaseId,
                        periodNumber: 3
                    }],
                id: purchase.purchaseId
            });
            parsedResponse.push(openView);
        }
        return parsedResponse;
    }
    reCalculateState(purchaseId, openviewModel) {
        let viewModel = this.openViewModels.find(model => model.purchaseId === purchaseId);
        viewModel = viewModel || openviewModel;
        if (viewModel) {
            viewModel.winningsData = {
                winnings: [
                    {
                        winningValue: this.getWiningValueFormatted(viewModel, 0),
                        winningStatus: this.getPeriodStatus(viewModel.pulseBetMetadata.periods[0].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[0].endTimeInMilli - viewModel.pulseBetMetadata.periods[0].startTimeInMilli) / 1000),
                        periodNumber: 1,
                        statusClass: this.getStatusClass(this.getPeriodStatus(viewModel.pulseBetMetadata.periods[0].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[0].endTimeInMilli - viewModel.pulseBetMetadata.periods[0].startTimeInMilli) / 1000))
                    },
                    {
                        winningValue: this.getWiningValueFormatted(viewModel, 1),
                        winningStatus: this.getPeriodStatus(viewModel.pulseBetMetadata.periods[1].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[1].endTimeInMilli - viewModel.pulseBetMetadata.periods[1].startTimeInMilli) / 1000),
                        periodNumber: 2,
                        statusClass: this.getStatusClass(this.getPeriodStatus(viewModel.pulseBetMetadata.periods[1].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[1].endTimeInMilli - viewModel.pulseBetMetadata.periods[1].startTimeInMilli) / 1000))
                    },
                    {
                        winningValue: this.getWiningValueFormatted(viewModel, 2),
                        winningStatus: this.getPeriodStatus(viewModel.pulseBetMetadata.periods[2].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[2].endTimeInMilli - viewModel.pulseBetMetadata.periods[2].startTimeInMilli) / 1000),
                        periodNumber: 3,
                        statusClass: this.getStatusClass(this.getPeriodStatus(viewModel.pulseBetMetadata.periods[2].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[2].endTimeInMilli - viewModel.pulseBetMetadata.periods[2].startTimeInMilli) / 1000))
                    }
                ],
                branchID: this.masterEvent.branchId
            };
        }
        if (viewModel) {
            for (let i = 0; i < 3; i++) {
                let winingsPeriod = this.getPeriodStatus(viewModel.pulseBetMetadata.periods[i].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[i].endTimeInMilli - viewModel.pulseBetMetadata.periods[i].startTimeInMilli) / 1000);
                let winingPlusCalcInterval = this.getPeriodStatus(viewModel.pulseBetMetadata.periods[i].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[i].endTimeInMilli - viewModel.pulseBetMetadata.periods[i].startTimeInMilli + 3000) / 1000);
                if (winingsPeriod !== winingPlusCalcInterval) {
                    viewModel.winningsData.winnings[i].winningStatus = winingPlusCalcInterval;
                    viewModel.winningsData.winnings[i].statusClass = this.getStatusClass(winingPlusCalcInterval);
                    setTimeout(this.updateWiningStatusDebounced.bind(this, viewModel.winningsData.winnings[i]), 3000);
                }
            }
        }
    }
    updateWiningStatusDebounced(data) {
        data.winningStatus = ProgressStatus.PostRun;
        data.statusClass = this.getStatusClass(ProgressStatus);
    }
    updateFinishedStatusDebounced(data) {
        data.isFinished = true;
    }
    /*istanbul ignore next */
    updateWiningsStatusOnComplete(data) {
        let openView = this.openViewModels.find(model => model.pulseBetProgressData.id === data.id);
        if (openView) {
            let period = openView.pulseBetProgressData.periods.find(prd => prd.periodNumber === data.periodNumber);
            if (period) {
                if (period.periodNumber === 3) {
                    setTimeout(this.updateWiningStatusDebounced.bind(this, openView.winningsData.winnings[2]), 2000);
                    setTimeout(this.updateFinishedStatusDebounced.bind(this, openView), 6000);
                    setTimeout(this.removeExpiredBet.bind(this, openView.purchaseId), this.removePulseInterval);
                }
                else {
                    openView.winningsData.winnings[period.periodNumber].winningStatus = ProgressStatus.Current;
                    openView.winningsData.winnings[period.periodNumber].statusClass = this.getStatusClass(ProgressStatus.Current);
                    openView.winningsData.winnings[period.periodNumber - 1].winningStatus = ProgressStatus.Resulting;
                    openView.winningsData.winnings[period.periodNumber - 1].statusClass = this.getStatusClass(ProgressStatus.Resulting);
                    setTimeout(this.updateWiningStatusDebounced.bind(this, openView.winningsData.winnings[period.periodNumber - 1]), 3000);
                }
            }
        }
    }
    /*istanbul ignore next */
    getPeriods(selections) {
        let periods = [];
        for (let key = 0, keysLength = selections.length - 1; key < keysLength; key += 1) {
            if (selections[key]) {
                let selection = selections[key];
                // NOTE:
                // We convert string arguments to number to match the definition in legacy
                let formatedOdds = +this.oddsUtil.convertFormat(+selection.odds, parseInt(selection.eventTypeId, 10), 13, undefined, 1, undefined, parseInt(selection.branchId, 10), undefined, undefined);
                let selectionInfo = {
                    europeanOdds: formatedOdds,
                    startTimeInMilli: selection.qPar1 * 1000,
                    endTimeInMilli: (selection.qPar1 + selection.qPar2) * 1000
                };
                periods.push(selectionInfo);
            }
        }
        return periods;
    }
    errorOpenPulseBetsCallback() { }
    /**
     * @function deactivate is called when BaseBlock is deactivated. It removes event listeners and stops BasePlayByPlay timer
     *
     */
    deactivate() {
        this.clearMyPulseBetData();
        delete this.masterEvent;
        this.openViewModels = [];
        this.isMyPulseBetActive = false;
        this.isAnyBetsAfterSettlement = true;
        this.animationStarted = 0;
    }
    /**
     * @function onPlayByPlayUpdate is called when 'onPlayByPlayUpdate' event is dispatched in BasePlayByPlay object.
     * It filters received incidents and call getMasterEventIncidents page method
     *
     * @param parsedResponse is an array of recieved PlayByPlay incidents
     */
    /*istanbul ignore next */
    onPlayByPlayUpdate(parsedResponse) {
        let playByPlayIncidents = parsedResponse;
        let filteredIncident = this.getIncidentPerType(playByPlayIncidents, PlayByPlayIncidentTypes.Goal);
        // NOTE:
        // Definition in legacy doesn't match the new definition
        if (filteredIncident && filteredIncident.masterEventID &&
            filteredIncident.masterEventID.toString() === this.masterEvent.id) {
            this.setDelayedOpenPulseBetsCallOnNotification();
        }
    }
    /**
     * @function getIncidentPerType filters the incidents acording to a type
     *
     * @param playByPlayIncidents it's an array with all play-by-play incidents
     * @param incidentType it's the incident type which has to be filtered
     */
    getIncidentPerType(playByPlayIncidents, incidentType) {
        return playByPlayIncidents.find(incident => incident.eventStatusID === incidentType);
    }
    /*istanbul ignore next */
    getPulseBetTypes() {
        return [
            {
                eventTypeId: PulseBetsTypes.ThirtySecPulse,
                eventTypeName: this.dict.ThirtySecPulse
            },
            {
                eventTypeId: PulseBetsTypes.OneMinPulse,
                eventTypeName: this.dict.OneMinPulse
            },
            {
                eventTypeId: PulseBetsTypes.FiveMinPulse,
                eventTypeName: this.dict.FiveMinPulse
            },
            {
                eventTypeId: PulseBetsTypes.TenMinPulse,
                eventTypeName: this.dict.TenMinPulse
            },
        ];
    }
    /*istanbul ignore next */
    removeExpiredBet(purchaseId) {
        let indexToRemove = this.openViewModels.findIndex(openBet => openBet.purchaseId === purchaseId);
        if (indexToRemove !== -1) {
            this.openViewModels.splice(indexToRemove, 1);
            if (!this.openViewModels.length) {
                this.isAnyBetsAfterSettlement = false;
                setTimeout(() => {
                    this.eventsManager.dispatchEvent("onUpdateMyPulseBet", this.openViewModels.length, true);
                    this.isAnyBetsAfterSettlement = true;
                }, this.redirectToDefaultGroupDelay);
            }
            else {
                this.eventsManager.dispatchEvent("onUpdateMyPulseBet", this.openViewModels.length, true);
            }
        }
    }
    get isGameRunning() {
        return this.masterEvent.gameStatus === GameStatuses.FirstHalf || this.masterEvent.gameStatus === GameStatuses.SecondHalf;
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], MyPulseBetsData.prototype, "isUserLogged", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], MyPulseBetsData.prototype, "currencySign", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], MyPulseBetsData.prototype, "openViewModels", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], MyPulseBetsData.prototype, "isMyPulseBetActive", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], MyPulseBetsData.prototype, "isAnyBetsAfterSettlement", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "onLogin", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "onLogout", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String, Number, Number, Boolean]),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "setParams", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "successfulOpenPulseBetsCallback", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, OpenPulseBetViewModel]),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "reCalculateState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [WinningDataInner]),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "updateWiningStatusDebounced", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OpenPulseBetViewModel]),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "updateFinishedStatusDebounced", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PulseBetProgressPeriodData]),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "updateWiningsStatusOnComplete", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MyPulseBetsData.prototype, "removeExpiredBet", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], MyPulseBetsData.prototype, "isGameRunning", null);
;
//# sourceMappingURL=MyPulseBetsData.js.map